export default __webpack_public_path__ + "static/media/email.cc38af24.svg";